import { Button, Dialog, Flex, IconButton, Text } from '@radix-ui/themes'
import { ArrowLeftIcon, Cross2Icon } from '@radix-ui/react-icons'

export const CancelReservationConfirmation = ({
  onCancel,
  onBack,
  errorMessage,
}: {
  onCancel: () => void
  onBack: () => void
  errorMessage?: string
}) => {
  return (
    <Flex direction="column" align="center" gap="4" style={{ padding: '18px 48px 48px 48px' }}>
      <Flex justify="between" style={{ width: '100%' }}>
        <Text size="2" style={{ cursor: 'pointer' }} onClick={onBack}>
          <Flex align="center" gap="1">
            <ArrowLeftIcon /> Back
          </Flex>
        </Text>
        <Dialog.Close>
          <IconButton variant="ghost" aria-label="Close">
            <Cross2Icon height="20" width="20" style={{ color: 'black' }} />
          </IconButton>
        </Dialog.Close>
      </Flex>

      <Text weight="bold" size="4" align="center">
        Are you sure you want to cancel?
      </Text>
      <Text size="2" color="gray" align="center">
        This will cancel the appointment and send a notice to the player, along with a prompt to
        re-schedule.
      </Text>

      {errorMessage && (
        <Text weight="bold" color="red" size="2">
          {errorMessage}
        </Text>
      )}

      <Button color="red" onClick={onCancel}>
        Delete
      </Button>
    </Flex>
  )
}
